<div class="wrap">
  <!-- <div class="sign-up" [routerLink]="['/home/sign-up']" routerLinkActive="router-link-active"(click)="dialog.closeAll()">S'inscrire</div> -->
  <ng-container *ngIf="!signup">
    <h2>Connectez-vous à votre espace personnel</h2>

    <div class="google-btn">
      <asl-google-signin-button type='standard' shape="rectangular" text="signin_with" locale="fr-FR" size="large"
        logo_alignment="left">
      </asl-google-signin-button>
    </div>

    <div class="sign_up_facebook" (click)="loginWithSocialMedia('facebook')">
      <div class="img"><img src="assets/img/icone/facebook-brands.svg" alt="facebook"></div>
      <span>Connexion avec Facebook</span>
    </div>

    <div class="or">
      <div class="ligne"></div>
      <span>Ou</span>
    </div>
    <app-form-sign-in [title]="'Connectez-vous à votre espace personnel'" [action]="'user'" component="openDialog">
    </app-form-sign-in>

    <div class="linksContainer">
      <a routerLink="/home/forgot-password" class="passwordLink" (click)="dialog.closeAll()">Mot de passe oublié ?</a>
      <a href="https://www.lvhdf.fr/index.php/privacy" class="policyLink" target="_blank">Politique de
        confidentialité</a>
    </div>

    <div class="btn_action">
      <button class="confirm" [routerLink]="['/home/sign-up']" routerLinkActive="router-link-active"
        (click)="dialogRef.close()">S'inscrire</button>
      <button class="back" (click)="dialogRef.close()">Retour</button>
    </div>
    <div class="load" *ngIf="load">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </ng-container>

  <app-register-rs *ngIf="signup" [userRS]="userRS"></app-register-rs>

</div>